import { FormEditTabType, FormSettingsTabType, getWebPath } from '@doss/common-all'
import { FiSave } from 'react-icons/fi'
import { HiOutlinePencilAlt } from 'react-icons/hi'
import { useNavigate, useSearchParams } from 'react-router'
import { Button } from '~/@/components/ui/button'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'
import { BreadcrumbObjectType } from '../../common/generated/apollo-operations'
import { DossSignalType, useDossSignals } from '../../common/hooks/useDossSignals'
import { ActionMenu } from './ActionMenu'
import { FormSettingsTabProvider } from './form-settings-tab/FormSettingsTabProvider'
import { FormVariantSwitcher } from './FormVariantSwitcher'
import { getSettingsTabFromQuery } from './utils'

export function FormEditActions({ formId }: { formId: string }) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { t } = useTypedTranslation()
  const { loading, dispatch, enableSaveButton } = useDossSignals()
  const currentTab = searchParams.get('tab') as FormEditTabType | undefined
  const currentVariantId = searchParams.get('variant') ?? undefined
  const isVariantMode = !!currentVariantId
  const isOnContentTab = currentTab === FormEditTabType.FORM_CONTENT || !currentTab

  const settingsTabParam = searchParams.get('settingsTab') ?? undefined
  const isOnSettingsDetailsTab = settingsTabParam
    ? getSettingsTabFromQuery(settingsTabParam) === FormSettingsTabType.DETAILS
    : false

  return (
    <FormSettingsTabProvider formId={formId}>
      <div className="flex items-center gap-2">
        {isOnContentTab && <FormVariantSwitcher formId={formId} />}
        <Button
          className="text-sm"
          onClick={() =>
            navigate(
              getWebPath({
                objectType: BreadcrumbObjectType.FORM,
                objectId: formId,
                variantId: currentVariantId,
              }),
            )
          }
          startIcon={<HiOutlinePencilAlt className="size-4" strokeWidth={1.6} />}
          variant="ghost"
        >
          {isVariantMode ? t('form.settings.fill_out_variant') : t('form.settings.fill_out_form')}
        </Button>
        {!isOnContentTab && (
          <Button
            className="text-sm"
            disabled={!formId || loading || !enableSaveButton}
            onClick={
              isOnSettingsDetailsTab
                ? () => dispatch(DossSignalType.UPDATE_FORM, { formId })
                : () => dispatch(DossSignalType.SAVE_FORM, { formId })
            }
            startIcon={<FiSave className="size-4" />}
            type="submit"
            variant="primary"
          >
            {t('common.actions.save')}
          </Button>
        )}
        <ActionMenu formId={formId} />
      </div>
    </FormSettingsTabProvider>
  )
}
